import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var updateBillingCancelSlice = createSlice({
    name: "updateBillingCancel",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updateBillingCancelSlice_actions = updateBillingCancelSlice.actions;
export var fetchData = _updateBillingCancelSlice_actions.fetchData, fetchDataSuccess = _updateBillingCancelSlice_actions.fetchDataSuccess, fetchDataFailure = _updateBillingCancelSlice_actions.fetchDataFailure, resetState = _updateBillingCancelSlice_actions.resetState;
export default updateBillingCancelSlice.reducer;
